"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAPIUrl = exports.setSharedAuthToken = exports.axios = void 0;
var axios_1 = __importDefault(require("axios"));
var apiUrl;
exports.axios = axios_1.default.create({
    baseURL: apiUrl,
});
function setSharedAuthToken(authToken) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    exports.axios.defaults.headers.common['Authorization'] = authToken;
}
exports.setSharedAuthToken = setSharedAuthToken;
function setAPIUrl(url) {
    apiUrl = url;
    // axios.defaults.baseURL = url
    exports.axios = axios_1.default.create({
        baseURL: apiUrl,
    });
}
exports.setAPIUrl = setAPIUrl;
//# sourceMappingURL=Axios.js.map